import ControlBase from '../fabric/ControlBase';
import { fabric } from 'fabric';

class ButtonControlBase extends ControlBase {
  cursorStyle = 'pointer';
  sizeX = 16;
  sizeY = 16;
  touchSizeX = 16;
  touchSizeY = 16;

  static icon: HTMLImageElement;

  static prepareIcon(svg: string) {
    const icon = new Image();
    icon.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;

    // Decode conditionally to workaround jest tests running in node not a browser.
    if ('decode' in icon) {
      icon.decode();
    }

    return icon;
  }

  render(
    ctx: CanvasRenderingContext2D,
    left: number,
    top: number,
    styleOverride: any,
    fabricObject: fabric.Object
  ): void {
    const { icon } = this.constructor as typeof ButtonControlBase;
    if (!icon) return;

    const { sizeX, sizeY } = this;

    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle!));
    ctx.drawImage(icon, -sizeX / 2, -sizeY / 2, sizeX, sizeY);
    ctx.restore();
  }
}

export default ButtonControlBase;
